import { useCallback, useState } from 'react';

/** YouTube video ids are always 11 chars from this alphabet. */
const YOUTUBE_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

const isYouTubeVideoId = (value: string): boolean => YOUTUBE_ID_PATTERN.test(value);

/** Tracks which video (if any) is playing inside the Untangled Ops modal. */
export const useVideoModal = () => {
  const [activeVideoId, setActiveVideoId] = useState<string | null>(null);

  const openVideoModal = useCallback((videoId: string) => {
    if (!isYouTubeVideoId(videoId)) return;
    setActiveVideoId(videoId);
  }, []);

  const closeVideo = useCallback(() => {
    setActiveVideoId(null);
  }, []);

  return {
    activeVideoId,
    isOpen: activeVideoId !== null,
    openVideoModal,
    closeVideo,
  };
};
